import axios from "~/plugins/axios";

export default {
  getById(emailAccountId, includes) {
    return axios.get(`/web_api/v1/email_account/${emailAccountId}`, { params: { includes } }).then((response) => response.data);
  },
  paginate(page, perPage, includes = []) {
    return axios.get("/web_api/v1/email_account", {
      params: {
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  getByUser(userId) {
    return axios.get(`/web_api/v1/email_account/by_user/${userId}`).then((response) => response.data);
  },
  get(includes = []) {
    return axios.get("/web_api/v1/email_account", { params: { include: includes } }).then((response) => response.data);
  },
  sync(accountId) {
    return axios.post(`/email_account/${accountId}/sync`).then((response) => response.data);
  },
};
